import getWithToken from './base/get-with-token'

const getUserInfo = id => getWithToken(`/user/${id}`)()

export default getUserInfo